<template>
  <v-app-bar
    app
    :color="navColor"
    :dark="darkNav"
    class="navbar px-sm-5 px-md-10"
    elevate-on-scroll
  >
    <router-link to="/" tag="div" class="navbar__brand d-flex align-center">
      <v-img
        alt="Lsaran Logo"
        class="shrink mr-2"
        contain
        src="@/assets/logo.svg"
        transition="scale-transition"
      />
      <BrandIconArm
        v-if="locale === 'am'"
        class="brandIcon"
        :color="brandColor"
      />
      <BrandIconRus
        v-else-if="locale === 'ru'"
        class="brandIcon"
        :color="brandColor"
      />
      <BrandIconEn v-else class="brandIcon" :color="brandColor" />
    </router-link>
    <div class="localeWrapper">
      <button
        class="localeButton"
        @click="setLocale('en')"
        :class="{
          activeLocaleButton: $i18n.locale === 'en',
          darkLocaleButton: !darkNav || pageScroll > 20
        }"
      >
        EN
      </button>
      <span>/</span>
      <button
        class="localeButton"
        @click="setLocale('am')"
        :class="{
          activeLocaleButton: $i18n.locale === 'am',
          darkLocaleButton: !darkNav || pageScroll > 20
        }"
      >
        AM
      </button>
      <span>/</span>
      <button
        class="localeButton"
        @click="setLocale('ru')"
        :class="{
          activeLocaleButton: $i18n.locale === 'ru',
          darkLocaleButton: !darkNav || pageScroll > 20
        }"
      >
        RU
      </button>
    </div>

    <v-spacer></v-spacer>
    <div class="navbar__menu d-none d-lg-flex">
      <v-menu
        open-on-hover
        close-delay="180"
        offset-y
        nudge-top="-12"
        v-for="(item, index) in menuItems"
        :key="index"
      >
        <template v-slot:activator="{ on, attrs }">
          <router-link
            :to="item.url"
            active-class="route-link-active"
            exact-active-class="route-link-active"
          >
            <a
              class="navbar__menu-item mx-4"
              v-bind="attrs"
              v-on="on"
              :style="{
                color: darkNav && pageScroll <= 20 ? '#fff' : '#1E1C37'
              }"
              :class="{
                linkActive: currentPage === item.url && currentPage !== '/'
              }"
            >
              {{ item.title }}
            </a>
          </router-link>
        </template>
        <v-list v-if="item.child.length !== 0">
          <v-list-item v-for="subItem in item.child" :key="subItem.title">
            <v-list-item-title>
              <router-link
                v-if="!subItem.href"
                tag="a"
                class="navbar__menu-subitem "
                :to="subItem.url"
                append
              >
                {{ subItem.title }}
              </router-link>
              <a
                v-else
                class="navbar__menu-subitem"
                target="_blank"
                :href="require(`@/assets/${subItem.href}`)"
                >{{ subItem.title }}</a
              >
            </v-list-item-title>
            <v-list-item-content> </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-btn
      fab
      icon
      large
      class="d-lg-none"
      :color="menuBtnColor"
      @click="$store.state.drawer = !$store.state.drawer"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import BrandIconEn from "@/components/icons/BrandIconEn";
import BrandIconRus from "@/components/icons/BrandIconRus";
import BrandIconArm from "@/components/icons/BrandIconArm";
export default {
  name: "Navbar",
  components: { BrandIconArm, BrandIconRus, BrandIconEn },
  props: ["darkNav"],
  computed: {
    menuItems() {
      return this.$t("common").menuItems ?? [];
    },

    navColor() {
      if (this.pageScroll > 20) {
        return "white";
      } else {
        return "transparent";
      }
    },

    brandColor() {
      return this.darkNav && this.pageScroll <= 20 ? "white" : "#2F2E43";
    },

    locale() {
      return this.$i18n.locale;
    },

    menuBtnColor() {
      if (this.darkNav) return this.pageScroll > 20 ? "#2F2E43" : "#fff";
      return "#2F2E43";
    },

    pageScroll() {
      return this.$store.state.pageScroll;
    },

    currentPage() {
      return this.$route.path;
    }
  },
  data: () => ({
    langChoose: "RU"
  }),
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    }
  }
};
</script>

<style lang="sass">
@import "./src/assets/style/vars"
.navbar
  &__brand
    cursor: pointer
  &__menu
    &-item
      transition: all .3s
      position: relative
      font-family: 'Inter', sans-serif !important
      font-weight: 700
      &:before
        content: ''
        width: 0
        height: 3px
        background-color: $activeColor
        position: absolute
        right: 0
        bottom: -10px
        transition: .3s
      &:hover
        color: $activeColor !important
        &:before
          width: 100%
          left: 0
    &-subitem
      color: $darkColor !important
      display: block
      width: 100%
      padding: 0 1rem
      transition: all .3s
      position: relative
      &:before
        content: ''
        width: 0
        height: 3px
        background-color: $activeColor
        position: absolute
        right: 0
        bottom: -10px
        transition: .3s
      &:hover
        color: $activeColor !important
        &:before
          width: 100%
          left: 0
  &__lang
    &-label
      opacity: .2
      cursor: pointer
      transition: all .3s ease

.linkActive
  color: $activeColor !important
  &:before
    content: ''
    width: 100%
    height: 3px
    background-color: $activeColor
    position: absolute
    right: 0
    bottom: -10px
    transition: .3s


.localeWrapper
  display: flex
  align-items: center
  margin-left: 24px

.localeButton
  cursor: pointer
  padding: 0 8px
  transition: all .2s

.darkLocaleButton
  color: #1E1C37

.activeLocaleButton
  color: rgba($activeColor, 1)

.brandIcon
  width: 84px
  height: 32px
</style>
